import React, { useEffect, useState } from 'react';
import './Accueil.css';
import auditImage from '../../Assets/Images/audit.jpg'
import Divider from '../../Components/Divider/Divider';
import ButtonContactUs from '../../Components/ButtonContactUs/ButtonContactUs';

const Accueil = () => {

  const [titleDevisSection, settitleDevisSection] = useState("")
  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 550px)');
    const handleMediaQueryChange = (event) => {
      const newTitle = event.matches ? <h3>Audit Légal <br />du commissaire <br />aux comptes</h3> : <h3>Audit Légal du commissaire aux comptes</h3>;
      settitleDevisSection(newTitle);
    };
    mediaQuery.addListener(handleMediaQueryChange);
    handleMediaQueryChange(mediaQuery);
    return () => mediaQuery.removeListener(handleMediaQueryChange);
  }, []);

  return (
    <div className="accueil">

      <div className="accueil-title">
        <h1>Cabinet d'expertise comptable</h1>
      </div>
      
      <section className='accueil-missions'>
          <div className='accueil-missions-image'>
            <img src={auditImage} alt="illustration audit" />
            <div className='accueil-missions-image-background'></div>
          </div>
          <div className='accueil-missions-container'>
            <div className="accueil-missions-title">
              <h3>MISSIONS DE TENUE</h3>
            </div>
            <div className="accueil-missions-content">
              <p style={{fontWeight: "bold"}}>Nous proposons à nos clients deux solutions pour effectuer la tenue comptable :</p>
              <p style={{fontWeight: "bold"}}>Internalisation de la comptabilité :</p>
              <div>
                <p>Vous faites l’acquisition d’un logiciel comptable et vous comptabilisez totalement ou partiellement les écritures comptables.</p>
                <p>Nous intervenons principalement pour l’enregistrement des écritures d’inventaires pour établir les comptes sociaux et fiscaux annuels.</p>
              </div>
              <p style={{fontWeight: "bold"}}>Externalisation de la comptabilité :</p>
              <p>La comptabilité est intégralement tenue dans nos locaux de Vincennes et sur notre propre logiciel comptable.</p>
            </div>
          </div>
        </section>

        <section className='accueil-audit'>
          {titleDevisSection}
          <div className='accueil-audit-content'>
            <p>Le commissaire aux comptes permet aux entités d’attester de la qualité de l’information comptable et financière mais aussi de prévenir et de réduire les risques liés à l’exploitation, à travers l’appréciation des procédures et l’appréciation du contrôle interne.</p> 
            <p>L’audit légal constitue soit une obligation légale soit une nécessité pour les dirigeants et les associés afin de garantir la transparence, la régularité et la sincérité de l’information financière communiquée.</p>
          </div>
          <ul className='accueil-audit-list'>
            <p>POUR RÉPONDRE À VOS BESOINS, NOUS RÉALISONS LES MISSIONS SUIVANTES :</p>
            <li>• Certification des comptes annuels</li>
            <li>• Examen des comptes intermédiaires</li>
            <li>• Rapport spécial sur les conventions réglementées</li>
            <li>• Vérifications spécifiques (contrôle des informations financières présentées aux assemblées)</li>
            <li>• Commissariat à la transformation ou à la scission</li>
            <li>• Commissariat aux apports</li>
          </ul>
          <ButtonContactUs />
        </section>
        <Divider />
    </div>
  )
}

export default Accueil;